// extracted by mini-css-extract-plugin
module.exports = {"timer":"timer_2GFU2","flashing0":"flashing0_1J2Y1","flashing1":"flashing1_Lcs1c"};